// =============================================================================
// src/config/zs_config.js
// ZS-only settings. Same file on every branch; applied in ./index.js only
// when ./deployment.js says DEPLOYMENT = 'zs', and they win over the env.
// Every key must be an export of ./index.js (zsOverrides.test.js).
// No secrets: this ships in the browser bundle.
// =============================================================================

const ZS_CONFIG = {
  // Off on ZS whatever the build args say: empty = feature off.
  TEAMS_APP_ID: '', // no Teams app; pages switch with the in-app router
  GOOGLE_CLIENT_ID: '', // no Google Drive picker
  GOOGLE_API_KEY: '',
  CLARITY_PROJECT_ID: '', // no Clarity analytics
};

export default ZS_CONFIG;
